<template>
  <div :style="'display: flex;width: 880px;'">
    <div v-if="pdfSrc" style="width: 100%; height: 100%">
      <el-scrollbar>
        <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" />
      </el-scrollbar>
    </div>
    <div v-if="excelSrc">
      <el-scrollbar>
        <vue-office-excel :src="excelSrc" class="office-preview" />
      </el-scrollbar>
    </div>
    <div v-if="wordSrc">
      <el-scrollbar>
        <vue-office-docx :src="wordSrc" class="office-preview" />
      </el-scrollbar>
    </div>
    <viewer v-if="photoList.length > 0" :images="photoList" class="preview-img">
      <img v-for="(item, index) in photoList" :key="index" :src="item">
    </viewer>
  </div>
</template>

<script>

import pdf from 'vue-pdf'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import URL from '@/api/urlTranslator'
import { cacheName, cache } from '@/utils/cacheManager'
import vueOfficeExcel from '@vue-office/excel'
import vueOfficeDocx from '@vue-office/docx'
import '@vue-office/excel/lib/index.css'
import { convertFileByFileId, findByFileId } from '@/api/storage'

export default {
  name: 'ImagePreviewBy',
  components: { pdf, CargoDialog, vueOfficeExcel, vueOfficeDocx },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    curFocus: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      URL,
      ctx: null,
      proportion: 1,
      img: null,
      pdfSrc: '',
      numPages: '',
      photoList: [],
      storageURL: '',
      wordSrc: '',
      excelSrc: ''
    }
  },
  watch: {
    imageInfo(val) {
      if (val) {
        this.init(val)
      }
    }
  },
  mounted() {
    this.init(this.details)
  },
  methods: {
    async init(value) {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      await this.handlePreviewFile(value)
    },
    async handlePreviewFile(fileObject) {
      const arr = fileObject.fileName.split('.')
      const fileType = arr[arr.length - 1].toLowerCase()
      const imgType = ['png', 'jpg', 'jpeg', 'gif', 'webp']
      let { pdfSrc, numPages, photoList, wordSrc, excelSrc } = this
      if (fileType === 'pdf') {
        const res = await findByFileId(fileObject.fileId)
        if (res && res.data) {
          const arrayBuffer = new Uint8Array(await res.data.arrayBuffer())
          const loadingTask = pdf.createLoadingTask(arrayBuffer)
          await loadingTask.promise.then(pdf => {
            numPages = pdf.numPages
          })
          pdfSrc = arrayBuffer
        }
      } else if (imgType.includes(fileType)) {
        const res = await findByFileId(fileObject.fileId)
        if (res && res.data) {
          const URL = window.URL || window.webkitURL
          const imgUrl = URL.createObjectURL(res.data)
          photoList = [imgUrl]
        }
      } else if (fileType === 'doc') {
        const res = await convertFileByFileId(fileObject.fileId, 'docx')
        if (res && res.data) {
          wordSrc = res.data
        }
      } else if (fileType === 'docx') {
        const res = await findByFileId(fileObject.fileId)
        if (res && res.data) {
          wordSrc = res.data
        }
      } else if (fileType === 'xls') {
        const res = await convertFileByFileId(fileObject.fileId, 'xlsx')
        if (res && res.data) {
          excelSrc = res.data
        }
      } else if (fileType === 'xlsx') {
        const res = await findByFileId(fileObject.fileId)
        if (res && res.data) {
          excelSrc = res.data
        }
      }
      this.pdfSrc = pdfSrc
      this.numPages = numPages
      this.photoList = photoList
      this.wordSrc = wordSrc
      this.excelSrc = excelSrc
    }
  }
}
</script>
<style lang="scss" scoped>
.preview-img{
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    max-width: 100%;
    min-width: 120px;
    min-height: 120px;
    height: auto;
  }
}

.office-preview {
  width: 100%;
  min-width: 880px;
  height: 100%;
  min-height: 1300px;
  border: none;
  padding-left: 20px;
}

</style>
